(ns client-portal.client.reports.components.ai-summary
  (:require [shared.core.style :as style]
            ["react-markdown" :default ReactMarkdown]
            ["remark-gfm" :default remarkGfm]))

(defn ai-summary [{:keys [summary style]}]
  (when (not-empty summary)
    [:div {:class-name "markdown-body"
           :style (merge {:padding "10px 14px"
                          :border-radius 8
                          :background-color (style/alc-color "Background/page")
                          :color (style/alc-color "Text/secondary")
                          :font-size 14
                          :line-height 1.4}
                         style)}
     [:> ReactMarkdown {:remarkPlugins [remarkGfm]
                        :children summary}]]))
